/**
 * HUC ids
 * We do not have huc12 yet; update this when it is added
 */
export const hucLayerIds = ['huc2', 'huc4', 'huc6', 'huc8', 'huc10'] as const;

export type HucLayerId = typeof hucLayerIds[number];

export type HucLevel = 2 | 4 | 6 | 8 | 10;

/**
 * Gets the appropriate HUC level to display based on zoom
 * Used for display purposes (like huc zoom level indicator)
 * 
 * @param zoom - Current map zoom level
 * @returns The HUC level that should be displayed
 */
export const getHucLevelForZoom = (zoom: number): HucLevel => {
  if (zoom < 4) return 2;
  if (zoom < 6) return 4;
  if (zoom < 7) return 6;
  if (zoom < 8) return 8;
  return 10;
};

/**
 * Gets the active HUC layer ID based on zoom level
 * Falls back to the highest available layer if the calculated level doesn't exist yet (e.g. huc12)
 * 
 * @param zoom - Current map zoom level
 * @returns The HUC layer ID that should be active
 */
export const getActiveHucLayerId = (zoom: number): HucLayerId => {
  const level = getHucLevelForZoom(zoom);
  const layerId = `huc${level}` as HucLayerId;
  return layerId;
};